import { defineStore } from 'pinia';

import { type User, type UserState } from './userState';
import { type UserRole, type UserProduct, ProductType, ProductName } from '@common/contracts';

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    const existsLocalStorageUser = localStorage.getItem('user');

    let userValue: User | null = null;

    if (existsLocalStorageUser) {
      const parsedLocalStorageUser = JSON.parse(existsLocalStorageUser) as User;

      userValue = parsedLocalStorageUser;
    }

    return {
      user: userValue,
    };
  },
  getters: {
    getLoggedInUser(): User | null {
      return this.user ?? null;
    },
    getLoggedInUserLogin(): string | null {
      return this.user?.login ?? null;
    },
    getLoggedInUserRole(): UserRole | null {
      return this.user?.role ?? null;
    },
    getLoggedInUserApps(): UserProduct[] | null {
      return this.user?.apps ?? null;
    },
    getLoggedInUserMarketingConsent(): boolean {
      return this.user?.marketingConsent ?? false;
    },
    getUserCalculators(): ProductName[] {
      return (
        this.user?.apps
          .map((p) => {
            if (p.type === ProductType.CALUCLATORS) {
              return p.name;
            }
            return undefined;
          })
          .filter((pName) => pName !== undefined) ?? []
      );
    },
  },
  actions: {
    setUser(user: User): void {
      this.user = user;

      localStorage.setItem('user', JSON.stringify(user));
    },
    removeUser(): void {
      this.user = null;

      localStorage.removeItem('user');
    },
    isVisibleGallery(): boolean {
      return !!this.user?.apps?.some((p) => p.type === ProductType.EVENT);
    },
    isVisibleGuestInfo(): boolean {
      return !!this.user?.apps?.some((p) => p.type === ProductType.EVENT || p.type === ProductType.RSVP);
    },
  },
});
